/* eslint-disable @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766 */
import '@atlassian/atlassian-connect-js/dist/connect-host.css';
import './host/host.css';
import './host/admin.css';
import './messages/main.css';
